import { coreInstance as axios, api } from 'settings';
import { logger } from 'helpers';
import * as actionTypes from '../../actionTypes';
import { engineeringParams } from '../../../../containers/EngineeringDashboard/Configs/constants';

const getO2PurityStart = () => {
	return {
		type: actionTypes.GET_O2_PURITY_START,
	};
};

const getO2PuritySuccess = (data) => {
	return {
		type: actionTypes.GET_O2_PURITY_SUCCESS,
		data: data,
	};
};

export const getO2Purity = (args = {}) => {
	const params = {
		...args.params,
		search: {
			...(args.params && args.params.search),
			param_id: engineeringParams.OXYGEN_PURITY,
		},
		searchFields: {
			...(args.params && args.params.searchFields),
			param_id: 'in',
		},
		orderBy: 'range',
	};

	return (dispatch) => {
		dispatch(getO2PurityStart());

		axios
			.get(api.engineering_params_statistics.index, { params })
			.then((response) => {
				logger('[Action] Get O2 purity');

				dispatch(getO2PuritySuccess(response.data.data));
			})
			.catch(() => {
				logger('[Action] Get O2 purity fail');
			});
	};
};
